import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl31 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".black{fill:currentColor" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Command_31",
		children: /* @__PURE__ */ _jsx("path", {
			className: "black",
			d: "M32,11c-6.62,0-12,5.38-12,12v6c0,.55.45,1,1,1h9v19h-4c-.55,0-1,.45-1,1v2c0,.55.45,1,1,1h12c.55,0,1-.45,1-1v-2c0-.55-.45-1-1-1h-4v-19h9c.55,0,1-.45,1-1v-6c0-6.62-5.38-12-12-12ZM42,28h-20v-5c0-5.51,4.49-10,10-10s10,4.49,10,10v5Z"
		})
	})]
});
export default SvgAppIcBefehl31;
